import styled from "styled-components";

const LoaderStyle = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export default LoaderStyle;
